import React from 'react';

import Loading from '@/components/common/Loading';

import styles from './index.module.scss';
import { useVideoPlayback } from './useVideoPlayback';
import { VideoControlBar } from './VideoControlBar';

export interface InlineVideoWithControlsProps {
  src: string;
  poster?: string;
  loop?: boolean;
  className?: string;
}

/** 内嵌视频 + 与全屏 VideoPlayer 相同的底部控制条（音量 / 播放 / 进度） */
const InlineVideoWithControls: React.FC<InlineVideoWithControlsProps> = ({
  src,
  poster,
  loop = false,
  className = '',
}) => {
  const {
    videoRef,
    isPlaying,
    isMuted,
    isLoading,
    progress,
    progressBarRef,
    formatTime,
    togglePlay,
    toggleMute,
    currentTime,
    duration,
    handleProgressClick,
    handleProgressMouseDown,
  } = useVideoPlayback({ src, loop });

  return (
    <div
      className={`${styles.compareModalVideoWrapper} ${styles.inlineShell} ${className}`.trim()}
    >
      <video
        ref={videoRef}
        src={src}
        poster={poster}
        className={styles.video}
        muted={isMuted}
        playsInline
        loop={loop}
        preload="metadata"
        onClick={(e) => {
          e.stopPropagation();
          togglePlay();
        }}
      />
      {isLoading && (
        <div className={styles.videoLoading}>
          <Loading />
        </div>
      )}
      <VideoControlBar
        isPlaying={isPlaying}
        isMuted={isMuted}
        togglePlay={togglePlay}
        toggleMute={toggleMute}
        formatTime={formatTime}
        currentTime={currentTime}
        duration={duration}
        progress={progress}
        progressBarRef={progressBarRef}
        handleProgressClick={handleProgressClick}
        handleProgressMouseDown={handleProgressMouseDown}
      />
    </div>
  );
};

export default InlineVideoWithControls;
